/**
* In this file contains the create password or reset password screen UI designs and create Password functionality
**/

import { Link,useNavigate } from 'react-router-dom';
import constantVariables from './../../dataset/constantVariables.json';
import { validate } from './../../services/ValidationService';
import { useState,useEffect } from 'react';
import * as Yup from 'yup';
import usePasswordToggle from './../../services/passwordService';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {generatePrivateKey,hashPassword,generatePasswordEPK} from './../../services/UtilsService';
import ApiService from './../../services/ApiService';

//New password create page
function CreatePassword() {
	
   //Variable declaration
   const [data,setData]=useState({});
   const [error,setError]=useState({});
   const [showPassword, togglePassword] = usePasswordToggle(false);
   const [showConfirmPassword, toggleConfirmPassword] = usePasswordToggle(false);
   const navigate =useNavigate();
   const userRole = Number(localStorage.getItem('role'));

   /** This function is used to cleaer the sessionStorage data when components destroy **/
   useEffect(()=>{
	   if(!sessionStorage.getItem('userEPK') || !sessionStorage.getItem('userId')){
		  if(userRole===4){
			return;
		  }
		  navigate('/');
	   }
	   return ()=>{
		  sessionStorage.clear();
	   }
	  // eslint-disable-next-line
   },[]);
   
   /**
   * Validation schema for Password set form
   * @newpassword pass the new password
   * @confirmPassword pass the conformpassword
   **/
   const paswordRestField = [
	{ name: 'newpassword', validation: Yup.string().required(constantVariables.error.required).matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, constantVariables.error.validPassword ) },
	{ name: 'confirmPassword', validation: Yup.string().required(constantVariables.error.required) }
   ];
   
   /**
  * To handle input change in Password field Set form
  * @e we capture the input fields events
  **/
  const handlePassword=async(e)=>{
	  e.preventDefault();
	  const {name,value}=e.target;  
	  setData({...data,[name]:value});
	  const Errors = await validate({ [name]: value }, paswordRestField);
	  setError({...error,[name]:Errors[name]});
  };
  
    /**
  * To handle the post the Set or reset Password
  * @e we capture the password form events
  **/
  const handleReset=async(e)=>{
	  e.preventDefault();
	  const Errors = await validate(data, paswordRestField);
	  setError(Errors);
	  if(!Object.keys(Errors).length){
		  if(data.newpassword===data.confirmPassword){
			 var userEPK=sessionStorage.getItem('userEPK') || '';
			 if(userRole===4){
				var userId= localStorage.getItem('userId');
			 }else{
				var userId= sessionStorage.getItem('userId') || '';
			 }
			 var request={};
			 userId=userId.replace(/-/g, '');
			 var privateKey=generatePrivateKey(userId.slice(0,10),userEPK);
			 request.password=hashPassword(data.newpassword);
			 request.passwordEPK=generatePasswordEPK(data.newpassword,privateKey); 
             request.user=userId;			 
			 var response=await ApiService.createPassword(request);
			 if (response.status === 200) {
				toast.success(response?.data?.message);
				if(userRole===4){
					var role = localStorage.getItem('role');
				 }else{
					var role = sessionStorage.getItem('userRole');
				 }
				sessionStorage.clear();
				
				// Redirect based on the role
				if (parseInt(role) === 3) {
				  navigate('/login/admin');
				} else if (parseInt(role) === 4) {
				  navigate('/login/hospital/admin'); // Add navigation for hospital admin
				} else {
				  navigate('/login/physician'); // Default case for physicians
				}
			  }
				   
			  
		  }else{
			 return toast.error(constantVariables.error.notMatchPassword);
		  }
	  }
  };
  
   
  return (
  <>
    {/** Create Password page  **/}
<main className="login-sec">
    <div className="container">

      <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
		{/** Logo **/}
          <div className="row justify-content-center">
            <div className="col-lg-12">
				<div className="d-flex justify-content-center pb-5">
					<Link to='/'  className="login-logo d-flex align-items-center">
						<img src="/assets/img/nurture-logo.svg" alt="lo" />
					</Link>
				</div>
				
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
				<div className="wrap d-md-flex">
					<img src="/assets/img/admin-login-img.jpg" alt="lo" />
					
					{/** Form **/}				
					<div id="loginForm">
						<h1>{constantVariables.auth.newPasswords}</h1>
						
						<form onSubmit={handleReset} autoComplete="off">
						  <div className="form-group my-4">
							<label className="mb-1">{constantVariables.auth.newPassword}</label>
							<OverlayTrigger trigger={['focus']} placement="right" overlay={<Popover
							id="popover-basic"
							title="Password Must:"
						  >
						  <h3 className="popover-header ng-star-inserted">{constantVariables.auth.passwordMust}</h3>
						  <div className="popover-body">
							<label className={`col ${(!data.newpassword || data?.newpassword?.length < 8) ? "text-danger" : "text-success"}`}>
							  {(!data.newpassword || data.newpassword?.length < 8)
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {constantVariables.error.passErrorOne}
							</label>
							<label className={`col ${(!data.newpassword || !/\d/.test(data.newpassword)) ? "text-danger" : "text-success"}`}>
								{(!data.newpassword || !/\d/.test(data.newpassword))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {constantVariables.error.passErrorTwo}
							</label>
							<label className={`col ${(!data.newpassword || !/[A-Z]/.test(data.newpassword)) ? "text-danger" : "text-success"}`}>
								{(!data.newpassword || !/[A-Z]/.test(data.newpassword))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {constantVariables.error.passErrorThree}
							</label>
							<label className={`col ${(!data.newpassword || !/[a-z]/.test(data.newpassword)) ? "text-danger" : "text-success"}`}>
								{(!data.newpassword || !/[a-z]/.test(data.newpassword))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {constantVariables.error.passErrorFour}
							</label>
							<label className={`col ${(!data.newpassword || !/[!@#$%^&*()\-_=+{};:,<.>]/.test(data.newpassword)) ? "text-danger" : "text-success"}`}>
								{(!data.newpassword || !/[!@#$%^&*()\-_=+{};:,<.>]/.test(data.newpassword))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {constantVariables.error.passErrorFive}
							</label>
							</div>
						</Popover>}>
							<input value={data.newpassword?data.newpassword:''} type={showPassword ? "text" :"password"} name="newpassword" onChange={handlePassword} className="form-control" placeholder="New Password" />
						</OverlayTrigger>
						<i className="iconly-Light-Lock"></i>
						<span className="eyeicon">
							<i className={showPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={togglePassword}></i>
						</span>
						{error && error.newpassword && <span className="text-danger">{error.newpassword}</span>}
						  </div>	
							<div className="form-group mb-4">
							<label className="mb-1">{constantVariables.auth.confirmPassword}</label>
							<input type={showConfirmPassword ? "text" :"password"} onChange={handlePassword} name="confirmPassword"  className="form-control" placeholder={constantVariables.auth.confirmPassword} />
							<i className="iconly-Light-Lock"></i>
							<span className="eyeicon">
								<i className={showConfirmPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={toggleConfirmPassword}></i>
							</span>
							{error && error.confirmPassword && <span className="text-danger">{error.confirmPassword}</span>}
						  </div>							  
						  <div className="mb-5">
							<button type="submit"  className="btn btn-tmBlue w-100">{constantVariables.profile.submit}</button>
						  </div>
						</form>
					</div>
					{/** Form end **/}
				</div>
            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
  {/** Create Password page end **/}
  </>
  );
}


export default CreatePassword;
